export default ({ store, redirect, route }) => {
  const [, locale] = route.path.split('/');
  let loginLink = locale === 'ar' ? '/ar/login' : '/login';
  if (!store.getters['auth/isLoggedIn']) {
    redirect(loginLink);
  }
};
